import React, { useState, useEffect, useCallback } from 'react';
import { useAjustes } from '../Context/AjustesContext';
import { Modal } from 'react-bootstrap';

function HeaderPublic() {
    const [scrolled, setScrolled] = useState(false);
    const { ajustes } = useAjustes();

    const getImageUrl = useCallback((path) => {
        if (!path) return null;
        if (path.startsWith('http')) {
            return path; // Already a full URL (external like Imgur)
        }
        return `${process.env.REACT_APP_API_URL}/${path}`;
    }, []);
    const [showSupportModal, setShowSupportModal] = useState(false);
    const [emailCopied, setEmailCopied] = useState(false);
    const [whatsappCopied, setWhatsappCopied] = useState(false);

    // Usar informações de contato dos ajustes do banco de dados
    const emailContato = ajustes?.email_contato;
    const whatsappContato = ajustes?.whatsapp_contato;
    
    // Formatar telefone para exibição (adicionar parênteses e traço)
    const formatarTelefone = (numero) => {
        if (!numero) return '(00) 00000-0000';
        // Remove tudo que não é número
        const apenasNumeros = numero.replace(/\D/g, '');
        // Se for formato internacional (inicia com 55)
        if (apenasNumeros.startsWith('55') && apenasNumeros.length === 13) {
            const ddd = apenasNumeros.substring(2, 4);
            const parte1 = apenasNumeros.substring(4, 9);
            const parte2 = apenasNumeros.substring(9);
            return `(${ddd}) ${parte1}-${parte2}`;
        }
        // Se for formato nacional (11 dígitos)
        if (apenasNumeros.length === 11) {
            const ddd = apenasNumeros.substring(0, 2);
            const parte1 = apenasNumeros.substring(2, 7);
            const parte2 = apenasNumeros.substring(7);
            return `(${ddd}) ${parte1}-${parte2}`;
        }
        return numero;
    };
    
    const telefoneContato = formatarTelefone(whatsappContato);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 10) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const copyToClipboard = async (text, type) => {
        try {
            await navigator.clipboard.writeText(text);
            if (type === 'email') {
                setEmailCopied(true);
                setWhatsappCopied(false);
                setTimeout(() => setEmailCopied(false), 3000);
            } else if (type === 'whatsapp') {
                setWhatsappCopied(true);
                setEmailCopied(false);
                setTimeout(() => setWhatsappCopied(false), 3000);
            }
        } catch (err) {
            console.error('Erro ao copiar:', err);
        }
    };

    return (
        <>
            <header className={`header-public header-container ${scrolled ? 'scrolled' : ''}`}>
                <nav className="navbar">
                    <div className="container-fluid px-3 px-md-4">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="navbar-brand m-0">
                                {ajustes.logo_white ? (
                                    <img 
                                        className="cursor-pointer" 
                                        alt={ajustes.titulo || "Logo"} 
                                        src={getImageUrl(ajustes.logo_white)}
                                        style={{ maxHeight: '35px', maxWidth: '140px' }}
                                        onClick={() => window.location.href = process.env.REACT_APP_URL || '/'}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = './../assets/logo-white.png';
                                        }}
                                    />
                                ) : (
                                    <img 
                                        className="cursor-pointer" 
                                        alt="Logo" 
                                        src="./../assets/logo-white.png"
                                        style={{ maxHeight: '35px' }}
                                        onClick={() => window.location.href = process.env.REACT_APP_URL || '/'}
                                    />
                                )}
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center gap-3 gap-md-4">
                                    <button 
                                        className="btn btn-none text-light p-0 fs-4 fs-md-3 px-2 py-1"
                                        onClick={() => setShowSupportModal(true)}
                                    >
                                        <i className="bi bi-headset"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            {/* Modal de Suporte */}
            <Modal show={showSupportModal} onHide={() => setShowSupportModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center">
                        <i className="bi bi-headset me-2"></i>
                        Suporte Técnico
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {/* Chat simulado */}
                    <div className="chat-container">
                        <div className="chat-message support-message">
                            <div className="chat-bubble">
                                <i className="bi bi-robot me-2"></i>
                                Olá! Como posso ajudá-lo hoje?
                            </div>
                            <small className="text-muted">Suporte - Agora</small>
                        </div>

                        <div className="chat-message support-message">
                            <div className="chat-bubble">
                                Escolha uma das opções abaixo para entrar em contato:
                            </div>
                        </div>

                        {/* Opção Email */}
                        <div>
                            <div className="support-option" onClick={() => copyToClipboard(emailContato, "email")}>
                                <div className="support-option-icon email">
                                    <i className="bi bi-envelope-fill"></i>
                                </div>
                                <div className="support-option-content">
                                    <div className="support-option-title">Email</div>
                                    <div className="support-option-subtitle">{emailContato}</div>
                                </div>
                                <i className="bi bi-copy"></i>
                            </div>
                            {emailCopied && (
                                <div className="copy-success-message">
                                    <i className="bi bi-check-circle me-1"></i>
                                    Email copiado com sucesso!
                                </div>
                            )}
                        </div>

                        {/* Opção WhatsApp */}
                        <div>
                            <div className="support-option" onClick={() => copyToClipboard(telefoneContato, "whatsapp")}>
                                <div className="support-option-icon whatsapp">
                                    <i className="bi bi-whatsapp"></i>
                                </div>
                                <div className="support-option-content">
                                    <div className="support-option-title">WhatsApp</div>
                                    <div className="support-option-subtitle">{telefoneContato}</div>
                                </div>
                                <i className="bi bi-copy"></i>
                            </div>
                            {whatsappCopied && (
                                <div className="copy-success-message">
                                    <i className="bi bi-check-circle me-1"></i>
                                    Número copiado com sucesso!
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <button 
                        className="btn btn-success w-100 d-flex align-items-center justify-content-center"
                        onClick={() => window.open(`https://wa.me/${whatsappContato}`)}
                    >
                        <i className="bi bi-whatsapp me-2"></i>
                        Chamar no WhatsApp
                    </button>
                </Modal.Footer>
            </Modal>

            <style>{`
                .header-public.header-container {
                    background: var(--bs-primary) !important;
                    box-shadow: none !important;
                    border: none !important;
                }
                .header-public.header-container.scrolled {
                    box-shadow: none !important;
                }
                .header-public .navbar {
                    box-shadow: none !important;
                    border: none !important;
                }
                .header-container {
                    background: var(--bs-primary);
                    box-shadow: none;
                    border: none;
                    transition: all 0.3s ease;
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 1030;
                }

                .header-container.scrolled {
                    box-shadow: none;
                    border: none;
                }

                .header-public .navbar,
                .header-public.header-container .navbar {
                    box-shadow: none !important;
                    border: none !important;
                }

                .navbar {
                    padding: 0.75rem 0;
                }

                .navbar-brand img {
                    transition: transform 0.3s ease;
                }

                .navbar-brand img:hover {
                    transform: scale(1.05);
                }

                .cursor-pointer {
                    cursor: pointer;
                }

                /* Chat Container */
                .chat-container {
                    padding: 20px;
                    background: #f8f9fa;
                    max-height: 400px;
                    overflow-y: auto;
                }

                .chat-message {
                    margin-bottom: 15px;
                }

                .support-message {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .chat-bubble {
                    background: white;
                    padding: 12px 16px;
                    border-radius: 18px 18px 18px 4px;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
                    max-width: 80%;
                    font-size: 14px;
                    line-height: 1.4;
                }

                .support-option {
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    padding: 16px;
                    margin: 10px 0;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .support-option:hover {
                    border-color: var(--bs-primary);
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    transform: translateY(-1px);
                }

                .support-option-icon {
                    width: 45px;
                    height: 45px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    color: white;
                    margin-right: 15px;
                }

                .support-option-icon.email {
                    background: #dc3545;
                }

                .support-option-icon.whatsapp {
                    background: #25d366;
                }

                .support-option-content {
                    flex: 1;
                }

                .support-option-title {
                    font-weight: 600;
                    color: #333;
                    font-size: 16px;
                }

                .support-option-subtitle {
                    color: #666;
                    font-size: 14px;
                    margin-top: 2px;
                }

                .support-option .bi-copy {
                    color: #666;
                    font-size: 18px;
                    transition: color 0.2s ease;
                }

                .support-option:hover .bi-copy {
                    color: var(--bs-primary);
                }

                .copy-success-message {
                    color: #198754;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: center;
                    padding: 8px;
                    margin-top: -5px;
                    margin-bottom: 5px;
                    animation: fadeInUp 0.3s ease-out;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </>
    );
}

export default HeaderPublic;
